export default __webpack_public_path__ + "assets/images/pricing/414681a2c1d9c4b9f8b1921e3218dfa9.png";